import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../redux-sagas/actions/leadsActions';
import Main from '../components/public/layout';

function mapStateToProps(state) {
    return {
        something: state.something
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actions, dispatch)
}

const App = connect(mapStateToProps, mapDispatchToProps)(Main);

export default App;
